/*
 * @Author: your name
 * @Date: 2022-04-07 15:43:33
 * @LastEditTime: 2022-05-10 18:48:08
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsyTableList\indexTd.jsx
 */
import React, { Component } from 'react';
import { BsyUtils } from '../../utils/Utils'
import { dayjsUtils } from '../../utils/dayjsUtils';

class TableHTd extends Component {

    _getCategory = (c) => {
        var str = "";
        switch (c) {
            case 0:
                str = React.language("manager.creator");
                break;
            // case 1:
            //     str = React.language("manager");
            //     break;
            // case 2:
            //     str = React.language("member");
            //     break;
            // case -1:
            //     str = React.language("Invited");
            //     break;
            case -2:
                if (window.FX.STATIC.user_corps && window.FX.STATIC.user_corps.mode && window.FX.STATIC.user_corps.mode === "common")
                    str = React.language("resigned.user");
                break;
            // case 6:
            //     str = React.language("unactivated");
            //     break;
            default:
                str = "";
        }
        return str;
    }

    render() {
        const { colVal, value } = this.props
        let role
        if (value.key === "role") {
            role = ""
            colVal[value.key].forEach((val, obj) => {
                role += (obj === colVal[value.key].length - 1) ? val.name : (val.name + ',')
            })
        }
        let cont = '';
        if(value.onGetText) {
            cont = value.onGetText(colVal[value.key]);
        } else {
            cont = value.key === "role" ? role : colVal[value.key];
        }

        const avatarurl = value.key === "nickname" ? colVal.avatarurl : false;
        const bg = value.key === "nickname" ? cont ? BsyUtils.formatUserThumb(cont.toString()) : '' : "";
        const again = value.key === "again" && colVal.category === -1;
        const category = this._getCategory(colVal.category);

        if(value.key === "leave_time"){
            cont = BsyUtils.date2Str(dayjsUtils.timeToTZ(colVal.leave_time), "yyyy-MM-dd HH:mm:ss");
        }


        const hasWidth = value.key === "role_id" || value.key === "dock_corpname" || value.key === "nickname" || value.key === "dock_user" || value.key === "user" || value.key === "corp" || value.key === "create_user" || value.hasWidth;
        return (
            <td className={value.key ? value.key : ''}>

                <div className={"cell " + (value.cls ? value.cls : '') }  style={{ "width": hasWidth ? (value.width ? value.width : "100%") : ""}}> {
                    value.onCellCreate ? value.onCellCreate(value,colVal) :
                        <>
                            {value.key === "nickname" && (avatarurl ? <img className="user-center" src={avatarurl} alt="" /> : <div className={`table-user-portrait-name color-${bg.color}`}><span>{bg.name}</span></div>)}
                            {value.key === "removeout" && <span className="removeout-text">{React.language('remove.out')}</span>}
                            <span title={value.title ? cont : ""} className={again ? "text again" : "text"}>{again ? React.language('member.invite.again') : cont}</span>
                            {value.key === "nickname" && category && <span className="category">{category}</span>}
                            {value.key === "nickname" && colVal.manager && <span className="category">{React.language('dept.manager')}</span>} 
                        </>
                }
                </div>
            </td>
        );
    }
}

export default TableHTd;